import {
  createSlice
} from '@reduxjs/toolkit';

export const queryVoluntaryResult = createSlice({
  name: 'queryVoluntaryResult',
  initialState: {
    data: {}
  },
  reducers: {
    fetchSuccess(state, action) {
      const {
        payload
      } = action;
      state.data = payload;
    },
  },
}).reducer;